import React, { useContext } from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { UiButton } from '@shared/ui';

import cls from './AddMediaButton.module.css';
import { FileInput } from '../../../../../components/newUI/FileInput/FileInput';
import { Icon } from '../../../../../components/newUI/Icon/Icon';
import { ProgressContext } from '../../../Context/ProgressContext';

interface AddMediaButtonProps {
    classes?: string;
    is_customer: boolean;
    progress_tariff_access_edit: boolean;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onNotOwnerHandler: () => void;
}

export const AddMediaButton = ({
    classes,
    handleInputChange,
    is_customer,
    progress_tariff_access_edit,
    onNotOwnerHandler,
}: AddMediaButtonProps) => {
    const { t } = useTranslation();

    const { isActiveMassSelectMode } = useContext(ProgressContext);

    return (
        <div className={cn(cls.AddMediaButton, [classes])}>
            {!is_customer && !isActiveMassSelectMode && (
                <>
                    {progress_tariff_access_edit ? (
                        <FileInput
                            accept=".jpg, .jpeg, .png, .gif, .mp4, .mov, .avi, .mkv, .m4v, .wmv, .webm, .asf"
                            onChange={handleInputChange}
                            classes={cls.input}
                            buttonText={t(
                                'ConstructionProgressBlock.return.header.fileInput.buttonText'
                            )}
                        />
                    ) : (
                        <UiButton
                            onClick={onNotOwnerHandler}
                            startIcon={<Icon iconName="plus" color="#F5F5F5" />}
                            btnText={t(
                                'ConstructionProgressBlock.return.header.fileInput.buttonText'
                            )}
                        />
                    )}
                </>
            )}
        </div>
    );
};
